import { render } from "./beltMonitor.vue?vue&type=template&id=6ddebee8&scoped=true"
import script from "./beltMonitor.vue?vue&type=script&lang=js"
export * from "./beltMonitor.vue?vue&type=script&lang=js"

import "./beltMonitor.vue?vue&type=style&index=0&id=6ddebee8&lang=scss&scoped=scoped"
import "./beltMonitor.vue?vue&type=style&index=1&id=6ddebee8&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddebee8"]])

export default __exports__